module.exports = __webpack_public_path__ + "img/icon-ai-picker-line@2x.68247550.png";